import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class UniversityPopularCourseService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(universityId): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_POPULAR_COURSE_LINK(universityId));
    }

    link(universityId, popularCourseIds: number[]): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITY_POPULAR_COURSE_LINK(universityId), {popular_course_ids: popularCourseIds});
    }

    unlink(universityId, popularCourseId): Observable<any> {
        return this.deleteRequest(AppUrl.UNIVERSITY_POPULAR_COURSE_LINK(universityId, popularCourseId));
    }
}
